import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import { ProjectBriefForm } from "./ProjectBriefForm.client";
import type { IProjectBriefFormBlockProps } from "./ProjectBriefFormBlock.props";

export const ProjectBriefFormBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  detailsLabel,
  emailLabel,
  eyebrow,
  heading,
  locationLabel,
  nameLabel,
  parentClass,
  projectTypes,
  sentencePrefix,
  spacing,
  submitLabel,
  successNote,
}: IProjectBriefFormBlockProps) => {
  if (!projectTypes?.length) return null;
  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-12 md:gap-16">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          layout="rail"
        />
        <ProjectBriefForm
          detailsLabel={detailsLabel}
          emailLabel={emailLabel}
          locationLabel={locationLabel}
          nameLabel={nameLabel}
          projectTypes={projectTypes}
          sentencePrefix={sentencePrefix}
          submitLabel={submitLabel}
          successNote={successNote}
        />
      </div>
    </DaylightSection>
  );
};

ProjectBriefFormBlock.displayName = "Block::ProjectBriefFormBlock";
